import { RichTextParser } from '@PetSureAustralia/petsure-react-ui-library/distLib/helpers';
import { stripHtml } from 'string-strip-html';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';
import { daysUntil } from '../../../utils/date';
import { replacePlaceholdersMultiplePatterns } from '../../../services/cms/HtmlResolver';
import { findByTaxonomyCodename } from '../../../utils/kontentAi/find';
import { BANNER_BUTTON_TAXONOMY_KEY, BANNER_MESSAGE_TAXONOMY_KEY, TAG_PATTERNS } from '../consts';

const getErrorBannerHtml = (contentData, cmsTagsData) => {
  const messageObject = contentData?.messageVariants?.find((item) => item?.system?.codename === 'error_message');
  const bodyContent = messageObject?.elements?.message_text?.value;
  if (!bodyContent) return undefined;

  return replacePlaceholdersMultiplePatterns(bodyContent, cmsTagsData, TAG_PATTERNS, false);
};

const getErrorBannerText = (contentData, cmsTagsData) => {
  const html = getErrorBannerHtml(contentData, cmsTagsData);
  if (!html) return {};

  const container = document.createElement('div');
  container.innerHTML = html;
  const heading = container.firstElementChild?.firstElementChild;
  let descriptionTitle;
  if (heading?.tagName === 'STRONG' && !heading.previousSibling?.textContent?.trim()) {
    descriptionTitle = stripHtml(heading.innerHTML).result.trim() || undefined;
    heading.remove();
  }

  return {
    descriptionTitle,
    description: stripHtml(container.innerHTML).result.trim() || undefined
  };
};

export const getErrorBannerDescription = (contentData, cmsTagsData) =>
  getErrorBannerText(contentData, cmsTagsData).description;

export const getErrorBannerDescriptionTitle = (contentData, cmsTagsData) =>
  getErrorBannerText(contentData, cmsTagsData).descriptionTitle;

export const getErrorBanner = (contentData, cmsTagsData) => {
  const html = getErrorBannerHtml(contentData, cmsTagsData);
  if (!html) return undefined;

  const buttonObject = contentData?.buttonVariants?.find((item) => item?.system?.codename === 'my_pets_page');

  return {
    body: RichTextParser(html),
    actionLabel: buttonObject?.elements?.button_text?.value,
    redirectUrl: CSPUrlsMap.myPets.url,
    icon: 'warning',
    variant: 'error'
  };
};

export const getBanners = (eligibilityData, contentData, cmsTagsData, singleBanner) => {
  return eligibilityData?.map((item) => {
    const messageObject = findByTaxonomyCodename(
      contentData.messageVariants,
      BANNER_MESSAGE_TAXONOMY_KEY,
      item?.RenewalStatus?.toLowerCase()
    );
    const bodyContent = messageObject?.elements?.message_text?.value;

    const buttonObject = findByTaxonomyCodename(
      contentData.buttonVariants,
      BANNER_BUTTON_TAXONOMY_KEY,
      item?.RenewalStatus?.toLowerCase()
    );
    const hideRenewButton = singleBanner && !item.CanRenewPolicy;
    const actionLabel = hideRenewButton ? undefined : buttonObject?.elements?.button_text?.value;

    const daysUntilExpiry = daysUntil(item.ExpiryDate);
    const contentPlaceholderValues = { ...item, ...cmsTagsData, csp_daysToExpiry: daysUntilExpiry };

    const body = RichTextParser(
      replacePlaceholdersMultiplePatterns(bodyContent, contentPlaceholderValues, TAG_PATTERNS, false)
    );

    const redirectUrl = `${item.CanRenewPolicy ? CSPUrlsMap.renewalHub.url : CSPUrlsMap.myPets.url}?policy=${
      item.PolicyNumber
    }`;

    const icon = 'warning';

    const variant = `warning`;

    return {
      body,
      actionLabel,
      redirectUrl,
      icon,
      variant,
      policyNumber: item.PolicyNumber,
      renewalStatus: item?.RenewalStatus?.toLowerCase(),
      canRenew: !!item.CanRenewPolicy,
      daysToExpiry: daysUntilExpiry
    };
  });
};
